:host {
  display: block;

    --jump-tabitem-active-color: var(--secondary-standard);
    --jump-tabitem-color: var(--neutral-grey-secondary);
    --jump-tabitem-hover-color: var(--neutral-grey-disabled, #CBCBCB);
    --jump-tabitem-boxed-bg-color: var(--secondary-soft, #EDF2FA);
    --jump-tabitem-rounded-bg-color: white;
    --jump-tabitem-border-inline-color: var(--neutral-grey-disabled, #CBCBCB);
    --jump-tabitem-font-size: 16px;
    --jump-tabitem-inline-padding: 12px 24px;
    --jump-tabitem-boxed-padding: 15px 39px;
    --jump-tabitem-rounded-padding: 12px 32px;
    --jump-tabitem-sheet-padding: 12px 32px;
  
    font-family: var(--ff-primary);

    flex: 0 0 auto;
  
    .Content {
  
      display: flex;

      &:hover:not(.disabled){
        cursor: pointer;
      }

      .label {
        font-size: var(--jump-tabitem-font-size);
      }
  
      &.left {
        flex-direction: row;
        gap: 6px;
        align-items: center;
      }
  
      &.top {
        flex-direction: column;
        gap: 2px;
        align-items: center;
      }
  
      /*Tipologia inline */
      &.inline {
        color: var(--jump-tabitem-color);
        padding: var(--jump-tabitem-inline-padding);
        border-bottom: 1px solid var(--jump-tabitem-border-inline-color);
      }

      &.inline:not(.active) {
        padding-bottom: 14px;
      }

      &.inline.active {
        color: var(--jump-tabitem-active-color);
        border-bottom: 3px solid var(--jump-tabitem-active-color);
  
        span {
          font-weight: bold;
        }
      }

      &.inline:hover:not(.disabled):not(.active) {
        border-bottom: 3px solid var(--jump-tabitem-hover-color);
        cursor: pointer;
        padding-bottom: 12px;
      }
  
      /* Tipologia boxed */
      &.boxed {
        color: var(--jump-tabitem-color);
        padding: var(--jump-tabitem-boxed-padding);
        background-color: transparent;
        border: 1px solid var(--jump-tabitem-boxed-bg-color);
      }
  
      &.boxed:hover:not(.disabled),
      &.boxed:hover:not(.active) {
        background-color: transparent;
  
        span {
          font-weight: bold;
        }
      }
  
      &.boxed.active {
        color: var(--jump-tabitem-active-color);
        background-color: var(--jump-tabitem-boxed-bg-color);
        border: 1px solid var(--jump-tabitem-boxed-bg-color);
  
        span {
          font-weight: bold;
        }
      }
  
      /* Tipologia rounded */
      &.rounded {
        padding: var(--jump-tabitem-rounded-padding);
        color: var(--jump-tabitem-color);
  
      }
  
      &.rounded:hover:not(.disabled) {
        cursor: pointer;
  
        span {
          font-weight: bold;
        }
      }
  
      &.rounded.active {
        color: var(--jump-tabitem-active-color);
        background-color: var(--jump-tabitem-rounded-bg-color);
        border: 1px solid var(--jump-tabitem-active-color);
        border-radius: 50px;
  
      }
  
      /** Tipologia sheet */
      &.sheet {
        padding: var(--jump-tabitem-sheet-padding);
        color: var(--neutral-grey-secondary);
      }
  
      &.sheet:hover:not(.disabled) {
        cursor: pointer;
  
        span {
          font-weight: bold;
        }
      }
  
      &.sheet.active {
        color: var(--jump-tabitem-active-color);
        background-color: var(--jump-tabitem-rounded-bg-color);
        border-radius: 8px 8px 0px 0px;
      }
    }
}

:host(.disabled) {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
}

